import type { Immutable } from 'immer';
import type { MapContext } from '../../store/maps/maps_reducers';
import { useStore } from '../../store/reducers';

export function useCurrentMapContext(): Immutable<MapContext> | null {
  return useStore((s) => s.maps.getter.currentMapContext());
}
